<template>
  <div id="directDepartment" v-if="data && data.length>0">
    <HomeTitle :data="titleData" @moreHandle="moreHandle"></HomeTitle>
    <div class="department-container">
        <div v-for="(item, index) in data.slice(0,4)"
             :key="index"
             :class="['department-box', 'color' + (index+1)]"
             @click="departmentHandle(item)">
          <p class="department-name">{{ item.deptName }}</p>
          <p class="service-type">入驻服务</p>
          <p class="service-num"><b>{{ item.serviceCount }}</b> 个</p>
          <div class="lattice-box">

          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getDepartment } from '@/api/home/index'
export default {
  name: "DirectDepartment",
  components: {
    HomeTitle: () => import('./HomeTitle')
  },
  props:[ 'title' ],
  data() {
    return {
      titleData: {
        title: this.title,
        more: true
      },
      data: []
    }
  },
  created() {
    this.getDepartmentList();
  },
  methods: {
    //获取部门列表
    getDepartmentList() {
      getDepartment().then(res => {
        if (res && res.code == 200) {
          this.data = res.data;
        }
      })
    },
    // 更多点击事件
    moreHandle() {
      this.$router.push("/homeTab/serviceHall");
    },
    //直通部门点击事件
    departmentHandle(item) {
      this.$router.push({
        path: "/homeTab/serviceHall",
        query: {
          deptId: item.deptId,
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.department-container {
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .department-box {
    position: relative;
    width: 167px;
    height: 92px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-radius: 5px;
    background-size: 47px 23px;
    flex-shrink: 0;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.department-name {
        height: 24px;
        line-height: 24px;
        @extend .font16;
      }

      &.service-type {
        height: 20px;
        margin-bottom: 5px;
        line-height: 20px;
        @extend .font13;
      }

      &.service-num{
        height: 23px;
        line-height: 23px;
        @extend .font11;

        b{
          font-size: 22px;
          font-weight: 600;
        }
      }
    }

    .lattice-box {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 48px;
      height: 24px;
    }

    &:nth-child(1) .lattice-box,
    &:nth-child(2) .lattice-box,
    &:nth-child(3) .lattice-box {
      background: url("../../assets/image/home/lattice01.png") no-repeat center/48px 24px;
    }

    &:nth-child(4) .lattice-box {
      background: url("../../assets/image/home/lattice02.png") no-repeat center/48px 24px;
    }

    &:nth-child(-n+2) {
      margin-bottom: 12px;
    }

    &.color1 {
      color: #5579A9;
      background: #E7EFFA;
    }

    &.color2 {
      color: #5564AA;
      background: #F3F5FF;
    }

    &.color3 {
      color: #855774;
      background: #FFF6FF;
    }

    &.color4 {
      color: #DCC551;
      background: #FFF8F1;
    }
  }
}
</style>
